import React, { useState } from 'react';
import { uploadFile } from '../api';
import LoadingSpinner from './LoadingSpinner';
import { ErrorState, EmptyState } from './shared/UIComponents';

function UploadFile({ onDataReceived }) {
  const [previewRows, setPreviewRows] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setError(null);
    setSuccess(null);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file to upload.');
      return;
    }
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const data = await uploadFile(file);
      const name = data.dataset_name || (file.name && file.name.replace(/\.[^.]+$/, ''));
      setPreviewRows(data.preview || []);
      setSuccess(data.message || `Dataset "${name}" uploaded successfully.`);
      onDataReceived && onDataReceived(data);
      setTimeout(() => setSuccess(null), 6000);
    } catch (err) {
      setError(err.message || 'Failed to upload file. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-file">
      <h3 className="upload-file__title">Upload File</h3>
      <input 
        type="file" 
        onChange={handleFileChange}
        disabled={loading}
        className="upload-file__input"
      />
      <button 
        onClick={handleUpload} 
        disabled={!file || loading}
        className="upload-file__upload-btn"
      >
        {loading ? (
          <LoadingSpinner size="small" text="Uploading..." />
        ) : (
          'Upload'
        )}
      </button>
      
      {loading && (
        <div className="upload-file__loading">
          <LoadingSpinner text="Uploading file..." />
        </div>
      )}

      {!loading && !file && !error && (
        <EmptyState
          title="No file selected"
          description="Choose a CSV file, then click Upload to create a dataset."
          icon="📄"
        />
      )}
      
      {success && (
        <div className="upload-file__success" style={{ marginTop: 8, color: 'var(--success, #0a0)', fontSize: 14 }}>
          ✓ {success}
        </div>
      )}
      {error && (
        <ErrorState
          message={error}
          onRetry={file ? handleUpload : null}
        />
      )}
      
      {/* {previewRows.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <h4>Preview (first 5 rows)</h4>
          <table border="1" style={{ width: '100%', fontSize: '12px' }}>
            <thead>
              <tr>
                {Object.keys(previewRows[0]).map((key) => (
                  <th key={key} style={{ padding: '4px', background: 'var(--primary)', color: 'var(--white)' }}>
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {previewRows.map((row, idx) => (
                <tr key={idx}>
                  {Object.values(row).map((val, i) => (
                    <td key={i} style={{ padding: '4px', border: '1px solid var(--border)' }}>
                      {val}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}
    </div>
  );
}
export default UploadFile;